<template>
  <div class="flex-column" style="width: 100%">
    <div class="relative m-5" style="height:460px;width: 818px">
      <div style="width: 818px;height:460px;position: relative" v-show="videoinfo.videoUrl">
        <video :src="videoinfo.videoUrl" alt="" controls id="video_prew_id" style="height:460px;object-fit: fill;"
               v-show="videoinfo.videoUrl" width="818px"/>
        <img :src="videoinfo.coverUrl" @click.stop="onVideoPlayClick" alt=""
             class="absolute top-0 left-0" style="width: 818px;height:460px;"
             v-if="videoinfo.videoUrl && videoinfo.coverUrl&& !isplay">
        <img @click.stop="onVideoPlayClick" class="play-img-style"
             src="../../assets/common/ic_shipinbiaozhi_white@2x.png"
             v-if="videoinfo.videoUrl && videoinfo.coverUrl && !isplay">
      </div>
      <video-player :poster="videoinfo.coverUrl" :vid="videoinfo.videoAliVid" aspectRatio="16:9"
                    class="m-0 video-style" ref="player"
                    v-show="!videoinfo.videoUrl && videoinfo.videoAliVid"/>
    </div>
    <div class="fs-14 m-v-2 m-t-5 w-full" style="word-break: break-all"
         v-html="videoinfo.content.replace(/\n/g, '<br>')">
    </div>
  </div>
</template>

<script>
import VideoPlayer from './VideoPlayer'

export default {
  name: 'VideosPrew',
  components: {VideoPlayer},
  props: {
    videoinfo: Object
  },
  data () {
    return {
      isplay: false
    }
  },
  methods: {
    onVideoPlayClick () {
      let video = document.getElementById('video_prew_id')
      if (video) {
        video.play()
        this.isplay = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .play-img-style {
    width: 50px;
    height: 50px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .video-style ::v-deep .video-js .vjs-big-play-button {
    /*
     播放按钮换成圆形
    */
    font-size: 2.5em;
    border-radius: 1em;
    margin-left: -1em;
  }

</style>
